// extracted by mini-css-extract-plugin
export default {"tooltip-box":"IconTooltip_tooltip-box__EYbVR"};